<template>
  <div class="edit">
    <Breadcrumb />
    <div class="edit-content">
      <div class="step-box">
        <step-add moduleType="extraTraining" @submit="allSubmit" :activeTab="activeTab"
          :isChangeTab="isChangeTab"></step-add>
      </div>
      <div class="form-box">
        <el-form ref="ruleForm" :rules="rules" :model="form" class="setp-form" label-width="125px" size="small">
          <el-form-item label="培训标题" prop="actTitle">
            <el-input v-model="form.actTitle" maxlength="200" show-word-limit type="textarea"
              :autosize="{ minRows: 5, maxRows: 8 }"></el-input>
          </el-form-item>
          <el-form-item label="培训级别" prop="classify3">
            <dic-code-selector dicType="trainLevel" v-model="form.classify3"></dic-code-selector>
          </el-form-item>
          <el-form-item label="培训时间" prop="endDate">
            <el-date-picker v-model="dateRange" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </el-form-item>
          <el-form-item label="培训地点" prop="address">
            <el-input type="textarea" v-model="form.address"></el-input>
          </el-form-item>
          <el-form-item label="参与教师" prop="joinUser">
            <el-checkbox-group key="2" v-model="form.groupCode">
              <el-checkbox v-for="i in groupOptions" :key="i.id" :label="i.groupCode">{{ i.groupName }}</el-checkbox>
            </el-checkbox-group>
            <span>
              指定教师
              <el-button type="text" @click="addOtherUser">添加</el-button>
              <el-button type="text" @click="cancelOtherUser">取消</el-button>
            </span>
            <div class="scorll-list" v-if="form.joinUsers.length > 0">
              <el-tag @close="tagJoinRemove(tag.userId)" size="small" v-for="tag in form.joinUsers" :key="tag.id"
                closable>{{ tag.userName }}</el-tag>
            </div>
            <join-pop @close="closeJoinPop" @joinUsersChange="joinUserChange" :showJoinPop="showJoinPop"
              v-if="showJoinPop"></join-pop>
          </el-form-item>
          <el-form-item label="培训时长" prop="actTime">
            <el-input v-model="form.actTime"></el-input>
          </el-form-item>
          <el-form-item label="培训体会或反馈" prop="actContent">
            <el-input v-model="form.actContent" maxlength="200" show-word-limit type="textarea"
              :autosize="{ minRows: 5, maxRows: 8 }" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="培训通知单" prop="actNotices">
            <fileAgent :multiple="true" meta v-model="form.actNotices" />
          </el-form-item>
          <el-form-item label="活动图片" prop="actPictures">
            <fileAgent theme="grid" :multiple="true" accept="image/*" v-model="form.actPictures" />
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb.vue'
import DicCodeSelector from '@/components/common/DicCodeSelector.vue'
import Face from '@/components/common/Face.vue'
import JoinPop from '@/components/common/JoinPop.vue'
import StepAdd from '@/components/common/StepAdd.vue'
import { getData, postJson } from '@/http/fetch.js'
import { mapState } from 'vuex'
import fileAgent from '../../components/school/fileAgent.vue'

export default {
  computed: {
    ...mapState(['userInfo', 'isAdmin']),
    dateRange: {
      get() {
        return [this.form.startDate, this.form.endDate]
      },
      set(v) {
        this.form.startDate = v[0]
        this.form.endDate = v[1]
      }
    }
  },
  components: {
    fileAgent,
    Face,
    Breadcrumb,
    StepAdd,
    DicCodeSelector,
    JoinPop
  },
  data() {
    return {
      activeTab: 'extraTranining', // eduForm活动新增  link环节   linkAdd 环节新增
      isChangeTab: false, //是否可以切换 tab
      groupOptions: [],
      showJoinPop: false,
      form: {
        actCode: null, //活动代码
        actContent: '', //培训方式
        actNotices: [], //培训通知单
        actPictures: [], //活动图片
        actTime: '', //培训时长
        actTitle: '', //培训标题
        address: '', //培训地点
        joinUsers: [],
        groupCode: [],
        classify3: '', //	培训级别1:0:国家级,1:市级,2:区级,3:校级,4:专项培训
        endDate: '', //	截止日期（yyyy-MM-dd HH:mm:ss）
        id: null, //活动ID,不为空则更新
        operatorId: '', //	操作者ID
        orgCode: '', //集团代码
        schoolCode: '', //校区代码
        startDate: '', //开始日期（yyyy-MM-dd HH:mm:ss）
        faceAttaches: '',
        isSign: 1
      },
      rules: {
        isSign: [
          { required: true, message: '请选择是否需要签到', trigger: 'change' }
        ],
        actContent: [
          { required: true, message: '请输入培训方式', trigger: 'blur' }
        ],
        actNotices: [
          { required: true, message: '请上传培训通知单', trigger: 'change' }
        ],
        actPictures: [
          { required: true, message: '请上传活动图片', trigger: 'change' }
        ],
        actTime: [
          { required: true, message: '请输入培训时长', trigger: 'blur' }
        ],
        actTitle: [
          { required: true, message: '请输入培训标题', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '请输入培训地点', trigger: 'blur' }
        ],
        classify3: [
          { required: true, message: '请选择培训级别', trigger: 'blur' }
        ],
        endDate: [
          { required: true, message: '请选择培训时间', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.init()
  },
  methods: {
    async init() {
      this.isChangeTab = true
      await this.groupList()
      let actCode = sessionStorage.getItem('actCode')
      if (actCode) {
        getData('/training/getActiveInfo', {
          actCode: sessionStorage.getItem('actCode'),
          operatorId: this.userInfo.userId
        }).then((res) => {
          this.form = res

          if (!res.groupCode) {
            this.$set(this.form, 'groupCode', [])
          } else {
            this.$set(this.form, 'groupCode', JSON.parse(res.groupCode))
          }
        })
      }
    },
    //下一步
    changIsChangeTab(code) {
      this.isChangeTab = code
    },
    //添加指定教师
    addOtherUser() {
      this.showJoinPop = true
    },
    //取消指定教师
    cancelOtherUser() {
      this.form.joinUsers = []
    },
    //关闭添加弹框
    closeJoinPop() {
      this.showJoinPop = false
    },
    //添加参与教师
    joinUserChange(users) {
      users.forEach((i) => {
        if (
          !this.form.joinUsers.map((item) => item.userId).includes(i.userId)
        ) {
          this.form.joinUsers.push(i)
        }
      })
    },
    //移除参与教师
    tagJoinRemove(userId) {
      this.form.joinUsers = this.form.joinUsers.filter(
        (i) => i.userId != userId
      )
    },
    async groupList() {
      let { records } = await postJson("/researchGroup/getResearchGroupInfoList", {
        operatorId: this.userInfo.userId,
        schoolCode: this.userInfo.orgCode || this.userInfo.schoolCode,
        pageNum: 1,
        pageSize: -1,
        isAdmin: this.isAdmin / 1,
      })
      this.groupOptions = records
      return new Promise((resolve) => {
        resolve()
      })
    },
    async allSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (!this.form.actCode) {
            this.form.orgCode = this.userInfo.orgCode
            this.form.schoolCode = this.userInfo.schoolCode
          }
          this.form.groupCode = JSON.stringify(this.form.groupCode)
          this.form.operatorId = this.userInfo.userId
          postJson('/training/saveOrUpdateExtraTrainingInfo', this.form).then(
            (res) => {
              this.$message.success('发布成功！')
              this.$router.push({ name: 'train' })
            }
          )
        } else {
          this.$message.error('请先完善活动信息 !')
        }
      })
    }
  },
  watch: {}
}
</script>

<style lang="less" scoped>
.edit {
  .edit-content {
    .step-box {
      margin-top: 15px;
    }

    .form-box {
      margin-top: 15px;
      background-color: #fff;
    }

    .link-list {
      margin-top: 15px;
      background-color: #fff;
    }

    .link-edit {
      margin-top: 15px;
      background-color: #fff;
    }
  }
}


.scorll-list {
  padding: 2px;
  border: 1px solid rgb(231, 227, 227);
  border-radius: 5px;
  min-height: 30px;
  max-height: 128px;
  overflow: auto;

  .el-tag {
    margin: 3.5px;
    padding: 0px 5px;
  }
}
</style>
